var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-upload",on:{"click":_vm.handleClick}},[_vm._t("default"),_c('input',{ref:"input",staticClass:"z-upload-input",attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept},on:{"change":_vm.handleChange}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }